module.exports = __webpack_public_path__ + "static/img/G.4e7e281.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/G.png
// module id = WtFL
// module chunks = 0